import React, { Dispatch, SetStateAction } from 'react';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';

import { SelectOption } from '../form/model';

interface CheckboxGroupProps {
  selectedIds: string[];
  setSelectedIds: Dispatch<SetStateAction<string[]>>;
  optionsList: SelectOption[];
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = (props) => {
  const { selectedIds, setSelectedIds, optionsList } = props;

  const handleCheckboxClicked = (optionId) => {
    let updatedSettings = [...selectedIds];
    if (selectedIds?.includes(optionId)) {
      updatedSettings = updatedSettings.filter((elem) => elem !== optionId);
    } else {
      updatedSettings.push(optionId);
    }

    setSelectedIds(updatedSettings);
  };

  return (
    <Grid container style={{ paddingLeft: '5%' }}>
      {optionsList?.map((option, index) => {
        return (
          <Grid item xs={12} key={`check-${index}`}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedIds?.includes(option.value)}
                  onChange={() => handleCheckboxClicked(option.value)}
                  name="notification_settings"
                  color="primary"
                />
              }
              label={option.label}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default CheckboxGroup;
